module.exports = __webpack_public_path__ + "static/media/notification.d18432fd.svg";